import React, { Component } from 'react';
import adsenseConfig from '../../config/adsense';
import './adUnit.css';

class AdUnit extends Component {
    componentDidMount() {
        this.pushAd();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slotKey !== this.props.slotKey || prevProps.pathKey !== this.props.pathKey) {
            this.pushAd();
        }
    }

    pushAd() {
        const { slotKey } = this.props;
        if (!adsenseConfig.isSlotReady(slotKey)) {
            return;
        }

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error) {
            // Duplicate push / ad blocker 등은 무시
            console.warn('AdSense push skipped:', error && error.message ? error.message : error);
        }
    }

    render() {
        const { slotKey, className } = this.props;

        if (!adsenseConfig.isSlotReady(slotKey)) {
            return null;
        }

        const slot = adsenseConfig.slots[slotKey];

        return (
            <div className={`adsense-wrap${className ? ` ${className}` : ''}`} aria-label="Advertisement">
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block' }}
                    data-ad-client={adsenseConfig.client}
                    data-ad-slot={slot}
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                />
            </div>
        );
    }
}

export default AdUnit;



// WEBPACK FOOTER //
// ./src/component/adsense/adUnit.js